import React, { useState, useEffect, useRef } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
// import Header from '../../components/header/header';
// import Footer from '../../components/footer/footer';
// import DashboardHeader from '../../components/organism/dashboardHeader';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import theme from '../../lib/theme';
//  import MiniDrawer from '../../components/organism/miniDrawer'
import { getFolioList } from "../../redux/actions/init";
import { logout } from "../../redux/actions/login";
// import { ThemeProvider } from '@material-ui/core';
import { RESET_LOADER } from '../../redux/types/loader';
import Navbar from './shared/navbar';
import Sidebar from './shared/sidebar';
import Footer from './shared/footer';
import { useSelector, useDispatch } from 'react-redux';
// import Content from '../../components/organism/content/content';
// import '../../components/pages/dashboard/dashboard.css';
import postLoginSideMenu from '../../services/postLoginMenu';
import guestZBFMenu from '../../services/guestZBFMenu';
import Cookie from '../../lib/cookie';
import './shared/shared.css';
import { fetchWithWait } from '../../helper/methods';
import { removeCookie } from "../../redux/actions/removeCookies";
import { useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
// import 'reactjs-popup/dist/index.css';
import './sessionExpiryPopup.css';
import globalVariable from "../globalVariable";

let cookie = new Cookie();
const PrivateRoute = ({ component: Component, restricted, ...rest }) => {
    let dispatch = useDispatch();
    const history = useHistory();
    const locationState = useLocation();


    console.log(rest, 'sujeetrest')
    let path = rest.match.path
    console.log(path, 'private', rest)

    const [option, setOption] = useState(postLoginSideMenu)
    let locationPath = rest.location.pathname;// currentUrl e.g. /dashboard/systematicPlan, /dashboard/transact/invest

    const [showPopup, setshowPopup] = useState(false);
    const singleTimeRef = useRef(false);

    // const getCurrentOption = (locationPath) => {
    //     console.log(locationPath,'locationPath')
    //     for (let i = 0; i <option.length; i++) {
    //         let { menu, subMenu } = option[i];
    //         let { linkTo } = menu;
    //         if (locationPath === `${linkTo}`) {
    //             return option[i];
    //         }
    //         if (subMenu) {
    //             for (let j = 0; j < subMenu.length; j++) {
    //                 let { menu } = subMenu[j];
    //                 let { linkTo } = menu;
    //                 if (locationPath === `${linkTo}`) {
    //                     return subMenu[j];
    //                 }
    //             }
    //         }
    //     }
    // }
    // let currentOption = getCurrentOption(locationPath);
    // const [selectedOption,setSelectedOption]=useState(currentOption ? currentOption['menu']['label'] : '');

    // const  handleDrawerOption = (selectedOption) => {
    //     setSelectedOption(selectedOption)
    // }

    const logoutClick = () => {
        dispatch(logout())
    }

    let guestMenu = useSelector(state => state.Auth.guestMenu);

    useEffect(() => {
        // Subscribe to the 'httpError' event
        console.log("rest.location.pathname", rest.location.pathname)
        // if (rest.location?.pathname != "/onboarding/personal") {
        const onHttpError = (status) => {
            if (status === "failed" && !singleTimeRef.current) {
                singleTimeRef.current = true;
                setshowPopup(true);
                localStorage.setItem('sessionExpired', true);
                localStorage.setItem('triggered401', true);
            }
        };

        let events = globalVariable.getPropertyByName("events");
        events.subscribe('httpError', onHttpError);
        // }

        console.log('mounting PrivateRoute');
        return (() => {
            console.log('unmounting PrivateRoute');
            // Clean up the subscription when the component unmounts
            events.unsubscribe('httpError', onHttpError);
        })

    }, []);

    useEffect(() => {
        if (guestMenu) {
            setOption(guestZBFMenu)
        } else {
            setOption(postLoginSideMenu)
        }
    }, [guestMenu])

    const popupClose = (e) => {
        let subroute = process.env.REACT_APP_MODE === 'production' ? '/aiftransaction/' : '/';
        let pathname = window.location.pathname;
        let updatedPathName = pathname.indexOf(subroute) === 0 ? pathname.replace(subroute, '/') : pathname
        let returnUrl = updatedPathName + (window.location.search ? window.location.search : '');

        let redirectPath = returnUrl ? `?returnUrl=${returnUrl}` : '';
        fetchWithWait({ dispatch, action: removeCookie() }).then(res => {
            // setshowPopup(false);
            localStorage.removeItem('sessionExpired');
            localStorage.removeItem('triggered401');
            // window.location.href = '/mutualfund/login';
            history.push(`/login${redirectPath}`, locationState?.state);
        }).catch(err => {
            console.log('err in removeCookie: ', err);
            // setshowPopup(false);
            localStorage.removeItem('sessionExpired');
            localStorage.removeItem('triggered401');
            // window.location.href = '/mutualfund/login';
            history.push(`/login${redirectPath}`, locationState?.state);
        })
    }

    // console.log(props,'privateRouter')
    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <React.Fragment>
            <div className="container-scroller">
                <Navbar logout={logoutClick} />
                {
                    showPopup ?
                        <>
                            <Popup open={showPopup} onClose={popupClose} className="sessionExpiredPP" modal>
                                {/* <div ref={overlayRef} className="popup-overlay" onClick={handleOverlayClick}> */}
                                {/* Popup content */}
                                <div className="popup-contents">
                                    <h2>Session Expired</h2>
                                    <p>Your session has been expired!! Kindly login again.</p>
                                    <button onClick={popupClose}>Login</button>
                                </div>
                                {/* </div> */}
                            </Popup>
                        </>
                        :
                        <div className="container-fluid page-body-wrapper">
                            {cookie.getCookie('sidekey') !== undefined && <Sidebar option={option} />}
                            <div className={`main-panel ${rest.hideSidebar ? `fullWidth` : ``}`} style={{}}>
                                <div className="content-wrapper">
                                    <div className="manage-ac-container">
                                        <Route {...rest} render={props => (<Component {...props} />)} />
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                }
            </div>

            {/* <div className={'dashboard'}>
                <ThemeProvider theme={theme}>
                   
                    <DashboardHeader logout={rest.logout} />
                    <div className={'drawer-content-container'}>
                        <MiniDrawer path={path} drawerOptions={option}
                            selectedDrawerOption={selectedOption}
                            handleDrawerOption={handleDrawerOption}
                            isDrawerOpen={rest.isDrawerOpen}
                        />
                        <Content drawerOptions={option} path={path}
                            isDrawerOpen={rest.isDrawerOpen}>

                                    <Route {...rest} render={props => (<Component {...props} />)} />
                            </Content>                        

                    </div>
                </ThemeProvider>
                
            </div> */}


        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    isDrawerOpen: state.isDrawerOpen,
    responseErrorSnack: state.responseError.responseErrorSnack,
    start: state.loader.start,
    stop: state.loader.stop,
})

const mapDispatchToProps = (dispatch) => ({
    getFolioList: () => dispatch(getFolioList()),
    logout: () => dispatch(logout()),
    resetLoader: () => dispatch({ type: RESET_LOADER })
})

export default withRouter(PrivateRoute)
//export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PrivateRoute));